import React from 'react';
import './TimeAndDistance.css';
import {formatBigNumbers} from '../../../Helpers.js';

import clock from 'static/img/clock.svg';
import road from 'static/img/road.svg';

const TimeAndDistance = (props) =>{
  const totalDistanceInKilometers = Math.floor(props.timeAndDistance.totalDistance / 1000);
  const totalTimeInMinues = props.timeAndDistance.totalTime;
  const timeInHours = Math.floor(totalTimeInMinues / 60);
  const timeInMinutes = totalTimeInMinues % 60;

  return (
    <div className="TimeAndDistance">

      <div className="TimeAndDistance-container TimeAndDistance-Points">
        <div className="TimeAndDistance-score">
          <span className="TimeAndDistance-value">{formatBigNumbers(timeInHours)}</span>
          <span className="TimeAndDistance-unit">h</span>
          {timeInHours < 999 &&
            <React.Fragment>
              <span className="TimeAndDistance-value">{(timeInMinutes < 10 ? '0'+timeInMinutes : timeInMinutes)}</span>
              <span className="TimeAndDistance-unit">min</span>
            </React.Fragment>
          }
        </div>
        <div className="TimeAndDistance-description">spent on activities</div>
        <img className="TimeAndDistance-icon" src={clock} alt="" />
      </div>

      <div className="TimeAndDistance-container TimeAndDistance-Money">
        <div className="TimeAndDistance-score">
          <span className="TimeAndDistance-value">{formatBigNumbers(totalDistanceInKilometers)}</span>
          <span className="TimeAndDistance-unit">km</span>
        </div>
        <div className="TimeAndDistance-description">on the road</div>
        <img className="TimeAndDistance-icon" src={road} alt="" />
      </div>

    </div>
  )
}

export default TimeAndDistance;



// WEBPACK FOOTER //
// ./src/screens/bfmPanel/TimeAndDistance/TimeAndDistance.js